import React from "react";
import { Form, Checkbox, Input, Radio, Row, Col } from "antd";

const Section7 = ({ formValues, setFormValues, handleNext }) => {
  const kpiList = [
    "Return on Ad Spend (ROAS) / ROI",
    "Conversion Rate (leads or sales)",
    "Cost Per Lead / Cost Per Acquisition (CPL/CPA)",
    "Click-Through Rate (CTR)",
    "Impressions / Reach",
    "Engagement Rate (likes, shares, comments)",
    "Website Traffic / Sessions",
    "Social Follower Growth",
    "Email Open / Click Rates",
    "Other (please specify)",
  ];

  const analyticsTools = [
    "Google Analytics",
    "Facebook/Meta Ads Manager",
    "Google Ads Reporting",
    "HubSpot/Marketing Automation",
    "SEMrush/Ahrefs/Moz",
    "Tableau/Power BI",
    "Custom Dashboards (Looker, Data Studio, etc.)",
    "Other (please specify)",
    "We do not use any analytics tools",
  ];

  const renderCheckboxGrid = (options, selectedValues, keyName) => (
    <Checkbox.Group
      value={selectedValues || []}
      onChange={(checked) => setFormValues({ ...formValues, [keyName]: checked })}
      style={{ width: "100%" }}
    >
      <Row gutter={[0, 8]}>
        {options.map((option) => (
          <Col span={12} key={option}>
            <Checkbox value={option}>{option}</Checkbox>
          </Col>
        ))}
      </Row>
    </Checkbox.Group>
  );

  return (
    <Form layout="vertical">
      <Form.Item label="27. Which key performance indicators (KPIs) do you routinely track and include in your client reports?">
        {renderCheckboxGrid(kpiList, formValues.kpis, "kpis")}
      </Form.Item>

      {formValues.kpis?.includes("Other (please specify)") && (
        <Form.Item label="Please specify other KPIs you track">
          <Input
            placeholder="Enter other KPIs"
            value={formValues.otherKpis || ""}
            onChange={(e) => setFormValues({ ...formValues, otherKpis: e.target.value })}
          />
        </Form.Item>
      )}

      <Form.Item label="28. How frequently do you provide performance reports to clients?">
        <Radio.Group
          value={formValues.reportingFrequency}
          onChange={(e) => setFormValues({ ...formValues, reportingFrequency: e.target.value })}
        >
          <Radio value="Weekly">Weekly</Radio>
          <Radio value="Biweekly">Biweekly</Radio>
          <Radio value="Monthly">Monthly</Radio>
          <Radio value="At the end of each campaign">At the end of each campaign</Radio>
          <Radio value="Quarterly">Quarterly</Radio>
          <Radio value="On request only">On request only</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item label="29. Which analytics or reporting tools do you use to generate those reports?">
        {renderCheckboxGrid(analyticsTools, formValues.analyticsTools, "analyticsTools")}
      </Form.Item>

      {formValues.analyticsTools?.includes("Other (please specify)") && (
        <Form.Item label="Please specify other analytics tools">
          <Input
            placeholder="Enter other tools"
            value={formValues.otherAnalyticsTools || ""}
            onChange={(e) =>
              setFormValues({ ...formValues, otherAnalyticsTools: e.target.value })
            }
          />
        </Form.Item>
      )}

      {/* <div style={{ textAlign: "right", marginTop: 24 }}>
        <Button type="primary" onClick={handleNext}>
          Next
        </Button>
      </div> */}
    </Form>
  );
};

export default Section7;
